import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import useDataStore from '../Data/dataStore';
import { API, isMobileWidth, linkToText, MOBILE_SAFE_RESIZE, productsPath, } from '../globalUtils';
import Div from '../Page/Div';
import ProductCard from '../UI/ProductCard';
import SelectButtons from '../UI/SelectButtons';
import CardSlider from '../UI/CardSlider';
import { Link } from 'react-router-dom';
import FixedContainer from '../Page/FixedContainer';
const ProductsSection = ({ content, idx, allowOpen, }) => {
    const data = useDataStore((state) => state.data);
    const products = data[API.products]?.products;
    const [activeFilter, setActiveFilter] = useState(null);
    const [mobileView, setMobileView] = useState(isMobileWidth());
    const mobileViewRef = useRef(mobileView);
    mobileViewRef.current = mobileView;
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        onResize();
        return () => {
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    const onResize = () => {
        const mobile = isMobileWidth();
        if (mobile && !mobileViewRef.current) {
            setMobileView(true);
        }
        if (!mobile && mobileViewRef.current) {
            setMobileView(false);
        }
    };
    if (!content || !products)
        return _jsx("div", { className: "products-wrapper" });
    const { title, details, filter_options, display, details_button } = content.products_section;
    const isInPage = display === 'in_page';
    const filteredProducts = !products
        ? []
        : !activeFilter
            ? products
            : products.filter((product) => product.categories.includes(activeFilter));
    const getProducts = () => (products ?? []).map((item, idx) => {
        const { name, summary, logo, slug, image, image_1 } = item;
        return (_jsx(ProductCard, { id: slug ?? '', name: name, summary: summary, logo: logo, image: image, image_1: image_1, index: idx, isHidden: !filteredProducts.includes(item), shortStartTime: mobileView, noScale: isInPage }, name));
    });
    const snappy = content.force_snap;
    const noScale = isInPage || mobileView;
    return (_jsx(FixedContainer, { idx: idx, allowOpen: allowOpen, blocked: !isInPage, sliderClassName: `products-wrapper${isInPage ? ' in-page' : ''}`, children: [
            !isInPage && (_jsx("div", { className: "products-title-spacer" }, "products-title-spacer")),
            _jsxs("div", { className: "products-title-wrapper", children: [_jsx(Div, { blocked: !allowOpen && snappy, className: "products-title", delay: 0, noScale: noScale, children: title }), _jsxs(Div, { blocked: !allowOpen && snappy, className: "products-mobile-details", delay: 1, noScale: noScale, children: [details, !!details_button && (_jsxs(_Fragment, { children: [_jsx("div", { className: "separator" }), _jsx(Link, { to: details_button.url, "aria-label": `Visit ${linkToText(details_button.url)}`, children: _jsx("div", { className: "button products-mobile-details-button", children: details_button.title }) })] }))] }), !isInPage && (_jsxs(_Fragment, { children: [_jsx(Div, { blocked: !allowOpen && snappy, className: "products-details", delay: 1, noScale: noScale, children: details }), filter_options && filter_options.length ? (_jsx(SelectButtons, { options: filter_options, selection: activeFilter ? [activeFilter] : [], onSelection: (item) => setActiveFilter(item), blocked: !allowOpen && snappy })) : null] }))] }, "products-title-wrapper"),
            isInPage ? (_jsx(CardSlider, { hasStepper: !mobileView, linkArrow: productsPath, startGap: true, details: {
                    text: details,
                    button: details_button
                        ? { url: details_button.url, title: details_button.title }
                        : undefined,
                }, isAllowed: allowOpen, children: getProducts() }, "slider")) : (_jsx("div", { className: "products-grid", children: getProducts() }, "products-grid")),
        ] }));
};
export default ProductsSection;
